module.exports = __webpack_public_path__ + "media/images/athletes/1985-f70024effe15f59d2ff64dde466412a8.png";